<template>
  <div class="row">
    <div class="col-md-12 my-4">
      <div class="btn-group float-right" role="group" aria-label="Basic example">
        <button v-if="isNew" type="button" class="btn btn-primary text-nowrap" @click="addPrescription">
          <i class="fas fa-plus"></i>
          Добавить терапию
        </button>
        <button v-else type="button" class="btn btn-primary text-nowrap" @click="updatePrescription">
          <i class="fas fa-edit"></i>
          Редактировать терапию
        </button>

        <button class="btn btn-light" @click="returnToList">
          <i class="fas fa-ban"></i>
          Отменить
        </button>

        <button v-if="!isNew && !isFavorite" type="button" class="btn btn-light text-nowrap" @click="addToFavorites">
          <i class="far fa-star"></i>
          Добавить в избранные
        </button>
        <button v-if="!isNew && isFavorite" type="button" class="btn btn-light text-nowrap" @click="removeFromFavorites">
          <i class="fas fa-star"></i>
          Удалить из избранных
        </button>

        <button v-if="!isNew && !isArchived" type="button" class="btn btn-light text-nowrap" @click="archivePrescription">
          <i class="fas fa-file-archive"></i>
          Поместить в архив
        </button>
        <button v-if="!isNew && isArchived" type="button" class="btn btn-light text-nowrap" @click="restorePrescription">
          <i class="far fa-file-archive"></i>
          Восстановить из архива
        </button>

        <button class="btn btn-danger" @click="deletePrescription">
          <i class="fas fa-trash-alt"></i>
          Удалить
        </button>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card p-3 shadow">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Название вещества</label>

          <div class="col-sm-8">
            <SelectSearch :data="ingredients" v-model="ingredient" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Форма</label>

          <div class="col-sm-8">
            <SelectSearch :data="formats" v-model="format" />
          </div>
        </div>

        <div class="form-group row mb-5">
          <label class="col-sm-4 col-form-label">В 1 дозе</label>

          <div class="col-sm-8">
            <SelectSearch :data="measures" v-model="measure" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Препарат</label>

          <div class="col-sm-8">
            <SelectSearch :data="drugsDropdown" v-model="drug" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label" for="quantity">Кол-во доз за 1 прием</label>

          <div class="col-sm-8">
            <input class="form-control" v-model="quantity" id="quantity">
          </div>
        </div>

        <div class="form-group row mb-5">
          <div class="col-sm-4 col-form-label">Кратность приема</div>

          <div class="col-sm-8">
            <div class="btn-group btn-group-toggle">
              <label
                  :class="'btn text-dark btn-outline-primary btn-light' + (time.includes(item.id) ? ' active' : '')"
                  v-for="item in times"
                  :key="item.id">
                <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.id"
                    :id="item.id"
                    v-model="time"> {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Длительность курса</label>

          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-5">
                <input class="form-control" v-model="duration">
              </div>

              <div class="col-sm-offset-1 col-sm-6">
                <div class="input-group">
                  <select class="form-control"
                          v-model="durationMeasure">
                    <option v-for="(item, index) in durationMeasures" :key="index" :value="index">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Назначить с</label>

          <div class="col-sm-8">
            <datepicker v-model="startDate" input-class="form-control" format="dd.MM.yyyy"/>
          </div>
        </div>

        <div class="form-group row mb-5">
          <div class="col-sm-4">Окончание курса</div>

          <div class="col-sm-8">
            <span v-if="finishDate">
              {{ formatDate(finishDate) }}
            </span>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4">Варианты упаковок</div>

          <div class="col-sm-8" v-if="currentDrug">
            {{ currentDrug.packages.map(pack => pack.count).join(', ') }}
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4">Кол-во доз в упаковке</div>

          <div class="col-sm-8">{{ countInPackage }} доз/уп</div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4">Расчет курса:</div>

          <div class="col-sm-8">
            <span v-if="countDays > 0">
              {{ countDays }} {{declensionNumbers(countDays, 'день')}},
            </span>

            <span v-if="totalQuantity > 0">
              {{ totalQuantity }}
              {{declensionNumbers(countDays, currentDrug ? currentDrug.format.name : '')}}
            </span>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4">Требуемое кол-во упаковок:</div>

          <div class="col-sm-8">
            <span v-if="countPackages > 0">
              {{ countPackages }} уп.
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card p-3 shadow">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label" for="comment">Комментарий</label>

          <div class="col-sm-8">
            <textarea class="form-control" rows="3" v-model="comment" id="comment"></textarea>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4 col-form-label">Условия приема</div>

          <div class="col-sm-8">
            <div class="checkbox" v-for="item in methods" :key="item.id">
              <label>
                <input type="checkbox" :name="item.name" :value="item.id" v-model="method">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label" for="note">Врачебные заметки</label>

          <div class="col-sm-8">
            <textarea class="form-control" rows="3" v-model="note" id="note"></textarea>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4 col-form-label">Состав</div>

          <div class="col-sm-8" v-if="currentDrug">
            {{currentDrug.ingredients}}
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4 col-form-label">Магазины</div>

          <div class="col-sm-8 col-form-label" v-if="currentDrug">
            <a
                v-for="stock in currentDrug.stocks"
                :key="stock.id"
                :href="stock.link"
                target="_blank"
                class="mr-1">
              {{stock.store.name}};
            </a>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4 col-form-label">Описание</div>

          <div class="col-sm-8 col-form-label" v-if="currentDrug">
            {{currentDrug.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import formatDate from '../../../utils/formatDate';
  import calculateDaysCount from '../../../utils/calculateDaysCount';
  import declensionNumbers from '../../../utils/declensionNumbers';
  import SelectSearch from '../../common/SelectSearch';
  import {MS_IN_DAY, FORMAT_NAMES} from '../../../constants';

  export default {
    name: 'ClientDrugForm',

    components: { Datepicker, SelectSearch },

    props: ['client', 'drugPrescription'],

    data() {
      return {
        ingredient: '',
        drug: '',
        format: '',
        measure: '',
        quantity: 1,
        duration: 1,
        durationMeasure: 'day',
        durationMeasures: {
          day: 'дн.',
          week: 'нед.',
          month: 'мес.',
        },
        startDate: new Date(),
        finishDate: new Date(),
        time: [],
        method: [],
        comment: '',
        note: '',
        countInPackage: 0,
        countPackages: 0,
        countDays: 0,
        totalQuantity: 0,
      };
    },

    created() {
      if (typeof this.drugPrescription !== 'undefined') {
        const measure = `${this.drugPrescription.drug.measure} ${this.drugPrescription.drug.measureUnit}`;

        this.quantity = this.drugPrescription.quantity;
        this.startDate = new Date(this.drugPrescription.startDate);
        this.finishDate = new Date(this.drugPrescription.finishDate);
        this.time = this.drugPrescription.times.map(time => time.id);
        this.method = this.drugPrescription.methods.map(method => method.id);
        this.comment = this.drugPrescription.comment;
        this.note = this.drugPrescription.note;
        this.measure = measure;
        this.drug = this.drugPrescription.drug.id;
        this.ingredient = this.drugPrescription.drug.ingredient.id;
        this.format = this.drugPrescription.drug.format.id;

        const compareDate = new Date(this.finishDate.getTime() + MS_IN_DAY);

        if (this.startDate.getDate() === compareDate.getDate()) {
          const yearsDiff = (compareDate.getFullYear() - this.startDate.getFullYear());

          this.duration = compareDate.getMonth() + (yearsDiff * 12) - this.startDate.getMonth();
          this.durationMeasure = 'month';
        } else {
          const durationInMs = compareDate.getTime() - this.startDate.getTime();
          const durationInDays = parseInt(durationInMs / MS_IN_DAY);

          if (durationInDays % 7 === 0 && durationInDays !== 0) {
            this.duration = durationInDays / 7;
            this.durationMeasure = 'week';
          } else {
            this.duration = durationInDays;
            this.durationMeasure = 'day';
          }
        }
      }
    },

    computed: {
      isNew() {
        return typeof this.drugPrescription === 'undefined';
      },

      isFavorite() {
        return !this.isNew && this.drugPrescription.favorite;
      },

      isArchived() {
        return !this.isNew && this.drugPrescription.archived;
      },

      ingredients() {
        return [{value: '', label: 'Выберите вещество...'}]
          .concat(this.$store.state.ingredients.map(({id, name}) => {
            return {value: id, label: name};
          }));
      },

      drugs() {
        return this.$store.state.drugs.filter(drug => {
          if (this.ingredient !== '' && drug.ingredient.id !== this.ingredient) {
            return false;
          }

          if (this.format !== '' && drug.format.id !== this.format) {
            return false;
          }

          const measure = `${drug.measure} ${drug.measureUnit}`;

          if (this.measure !== '' && measure !== this.measure) {
            return false;
          }

          return true;
        });
      },

      currentDrug() {
        return this.$store.state.drugs.find(drug => drug.id === this.drug);
      },

      drugsDropdown() {
        return [{value: '', label: 'Выберите препарат...'}]
          .concat(this.drugs.map(({id, name, measure, measureUnit, manufacturer}) => {
            return {
              value: id,
              label: `${name} ${measure} ${measureUnit} ${manufacturer ? manufacturer.name : ''}`,
            };
          }));
      },

      formats() {
        const filteredFormats = this.drugs.map(drug => drug.format.id);
        const formats = this.$store.state.formats.filter(
          format => filteredFormats.includes(format.id)
        );

        return [{value: '', label: 'Выберите форму...'}]
          .concat(formats.map(({id, name}) => ({value: id, label: name})));
      },

      measures() {
        const measures = [];

        this.drugs.forEach(drug => {
          const measure = `${drug.measure} ${drug.measureUnit}`;

          if (!measures.includes(measure)) {
            measures.push(measure);
          }
        });

        measures.sort();

        return [{value: '', label: 'Выберите дозировку...'}]
          .concat(measures.map(value => ({value, label: value})));
      },

      methods() {
        return this.$store.state.methods;
      },

      times() {
        return this.$store.state.times;
      },
    },

    watch: {
      startDate: function () {
        this.recalculateDateFinish();
        this.recalculatePackages();
      },

      duration: function (value) {
        if(isNaN(parseInt(value))) {
          this.duration = 1;
        } else {
          this.duration = parseInt(value);
        }

        this.recalculateDateFinish();
        this.recalculatePackages();
      },

      durationMeasure: function () {
        this.recalculateDateFinish();
        this.recalculatePackages();
      },

      quantity: function () {
        this.recalculatePackages();
      },

      time: function () {
        this.recalculatePackages();
      },

      drug: function () {
        const drug = this.drugs.find(drug => drug.id === this.drug);

        if (this.isNew) {
          this.comment = drug.instruction;
          this.note = drug.information;
          this.method = drug.methods.map(method => method.id);
          this.time = drug.times.map(time => time.id);
        }

        this.recalculatePackages();
      },
    },

    methods: {
      getPrescriptionData() {
        return {
          drug: this.drug,
          quantity: this.quantity,
          startDate: this.startDate,
          finishDate: this.finishDate,
          times: this.time.map(time => time),
          methods: this.method.map(method => method),
          comment: this.comment,
          note: this.note,
        };
      },

      async addPrescription() {
        try {
          await this.$store.dispatch('ADD_DRUG_PRESCRIPTION', {
            data: Object.assign({ client: this.client.id }, this.getPrescriptionData()),
          });

          this.returnToList();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async updatePrescription() {
        try {
          await this.$store.dispatch('UPDATE_DRUG_PRESCRIPTION', {
            prescriptionId: this.drugPrescription.id,
            clientId: this.client.id,
            data: this.getPrescriptionData(),
          });

          this.returnToList();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async archivePrescription() {
        try {
          await this.$store.dispatch('ARCHIVE_DRUG_PRESCRIPTION', {
            prescriptionId: this.drugPrescription.id,
            clientId: this.client.id,
          });

          this.returnToList();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async restorePrescription() {
        try {
          await this.$store.dispatch('RESTORE_DRUG_PRESCRIPTION', {
            prescriptionId: this.drugPrescription.id,
            clientId: this.client.id,
          });

          this.returnToList();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async deletePrescription() {
        try {
          await this.$store.dispatch('DELETE_DRUG_PRESCRIPTION', {
            prescriptionId: this.drugPrescription.id,
            clientId: this.client.id,
          });

          this.returnToList();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async addToFavorites() {
        try {
          await this.$store.dispatch('ADD_DRUG_PRESCRIPTION_TO_FAVORITES', {
            clientId: this.client.id,
            prescriptionId: this.drugPrescription.id,
          });

          this.$forceUpdate();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async removeFromFavorites() {
        try {
          await this.$store.dispatch('REMOVE_DRUG_PRESCRIPTION_FROM_FAVORITES', {
            clientId: this.client.id,
            prescriptionId: this.drugPrescription.id,
          });

          this.$forceUpdate();
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      formatDate(date) {
        return formatDate(date, 'd.m.y');
      },

      declensionNumbers(count, name) {
        const formatName = FORMAT_NAMES.find(item => item[0] === name);
        const [, few, one, two ] = formatName || [name, name, name, name];

        return declensionNumbers(count, few, one, two);
      },

      recalculateDateFinish() {
        const finishDate = new Date(this.startDate.getTime());
        const duration = parseInt(this.duration);

        if (this.durationMeasure === 'month') {
          finishDate.setMonth(finishDate.getMonth() + duration);
        } else {
          const daysAdd = duration * (this.durationMeasure === 'week' ? 7 : 1);

          finishDate.setDate(finishDate.getDate() + daysAdd);
        }

        finishDate.setDate(finishDate.getDate() - 1);

        this.finishDate = finishDate;
      },

      recalculatePackages() {
        const drug = this.drugs.find(drug => drug.id === this.drug);

        if (!drug) {
          return;
        }

        this.countDays = calculateDaysCount(this.startDate.getTime(), this.finishDate.getTime());

        this.totalQuantity = this.time.length * this.quantity * this.countDays;
        const packages = drug.packages.map(pack => pack.count);

        packages.sort((a, b) => a - b);

        for (const pack of packages) {
          this.countInPackage = pack;
          this.countPackages = 1;

          if (pack >= this.totalQuantity) {
            return;
          }
        }

        this.countPackages = Math.ceil(this.totalQuantity / this.countInPackage);
      },

      returnToList() {
        this.$emit('return-to-list');
      },
    }
  };
</script>
